module.exports = {
  bedrock: {
    host: 'https://pocket.realms.minecraft.net',
    userAgent: 'MCPE/UWP',
    relyingParty: 'https://pocket.realms.minecraft.net/'
  },
  java: {
    host: 'https://pc.realms.minecraft.net',
    userAgent: 'MinecraftLauncher/2.2.10675'
  }
}
